import { useState, useEffect } from "react";
import { CgSpinner } from "react-icons/cg";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

import { toast } from "react-toastify";
import { db } from "../../firebase";

function EnquiryForm({ modelName, onClose, navigate }) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    model: modelName || "",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setForm((prev) => ({ ...prev, model: modelName || "" }));
  }, [modelName]);

  const pattern = /^[6-9][0-9]{9}$/;

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Special handling for phone (numbers only)
    const newValue = name === "phone" ? value.replace(/\D/g, "") : value;

    setForm((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.name || !form.phone || !form.model) {
      toast.error("Please fill all required fields");
      return;
    }

    if (!pattern.test(form.phone)) {
      toast.error("Invalid phone number");
      return;
    }

    setLoading(true);

    try {
      await addDoc(collection(db, "enquiries"), {
        ...form,
        name: form.name.trim(),
        email: form.email.trim(),
        formType: "on-road-price",
        timestamp: serverTimestamp(),
      });

      toast.success("Form submitted successfully");

      setForm({
        name: "",
        email: "",
        phone: "",
        model: modelName || "",
      });

      onClose?.();
      navigate?.("/thank-you");
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-xl p-6 w-full max-w-md relative">
      {/* CLOSE */}
      <button
        onClick={onClose}
        className="absolute top-3 right-4 text-xl font-bold"
      >
        ✕
      </button>

      <p className="font-semibold text-xl mb-5">Get On Road Price</p>

      <form onSubmit={handleSubmit}>
        {/* NAME */}
        <div className="mt-3">
          <label>Name *</label>
          <input
            type="text"
            name="name"
            className="border w-full rounded p-2"
            value={form.name}
            onChange={handleChange}
            required
          />
        </div>

        {/* EMAIL */}
        <div className="mt-3">
          <label>Email</label>
          <input
            type="email"
            name="email"
            className="border w-full rounded p-2"
            value={form.email}
            onChange={handleChange}
          />
        </div>

        {/* MOBILE */}
        <div className="mt-3">
          <label>Mobile *</label>
          <input
            type="text"
            name="phone"
            className="border w-full rounded p-2"
            value={form.phone}
            maxLength={10}
            onChange={handleChange}
            required
          />
          {!pattern.test(form.phone) && form.phone.length === 10 && (
            <small className="text-red-500">Invalid phone number</small>
          )}
        </div>

        {/* MODEL */}
        <div className="mt-3">
          <label>Model</label>
          <input
            type="text"
            name="model"
            value={form.model}
            readOnly
            className="border w-full rounded p-2 bg-gray-100"
          />
        </div>

        {/* SUBMIT */}
        <button
          type="submit"
          disabled={loading || !pattern.test(form.phone)}
          className="bg-red-600 text-white w-full mt-5 py-2 rounded flex justify-center items-center"
        >
          {loading ? <CgSpinner className="animate-spin text-xl" /> : "Submit"}
        </button>
      </form>
    </div>
  );
}

export default EnquiryForm;
